/* eslint-disable no-undef */
/* eslint-disable no-console */

(function ($) {

	$(function () {

		// console.log(
		// 	"Width: " +
		// 	window.innerWidth +
		// 	", Height: " +
		// 	window.innerHeight
		// );



		if (
			!$('html').hasClass('main-menu-open') &&
			!$('body').hasClass('transparent-header')
		) {

			// Select all div.content-wrapper elements with an immediate child article
			$('div.content-wrapper > article').each(function () {
				// Check if the first div within the article has the specified class
				if ($(this).children('div').first().hasClass('cc--hero-stories-full-width-carousel')) {
					// Perform actions here
					// console.log('Found the required structure.');
					// Example action: Add a class to the content-wrapper
					$('body').addClass('transparent-header');
				}
			});
		}




		/**
		 * Allows the clicking of H2 headings to copy the URL with the heading ID to the clipboard.
		 * This is useful for sharing a link to a specific section of a page.
		 * Only works for logged-in 'administrator' users.
		 */
		if ($('body.admin-logged-in').length > 0) {

			$('.f--section-title').on('click', function () {

				const $this = $(this);
				const $this_id = $this.find('h2').attr('id');
				const url = window.location.href.split('#')[0] + '#' + $this_id;

				// Use the Clipboard API to copy the URL
				navigator.clipboard.writeText(url).then(function() {

					$this.find('h2').addClass('show-popup');

					setTimeout(() => {
						$this.find('h2').removeClass('show-popup');
					}, 2000);

				}).catch(function(err) {
					// console.error('Could not copy text: ', err);
				});

			});

		}

		/**
		 * Check the URL for a hash and highlight the corresponding element if found.
		 */
		function highlightElementFromHash() {
			const hash = window.location.hash;
			if (hash) {
				const $target = $(hash);
				if ($target.length) {
					$target.addClass('highlighted');
					setTimeout(() => {
						$target.removeClass('highlighted');
					}, 4000);
				}
			}
		}

		// Run the function on page load
		highlightElementFromHash();

		// Also run the function on hashchange (e.g., when user navigates using browser history)
		$(window).on('hashchange', function() {
			highlightElementFromHash();
		});
		/**
		 * Check the URL for a hash and highlight the corresponding element if found.
		 */




		/**
		 * If the page has a transcript container, add a button to toggle the transcript visibility.
		 */
		if ($('.transcript-container').length > 0) {

			$('.transcript-toggle').on('click', function(e) {
				e.preventDefault();
				var $transcriptContent = $('#' + $(this).attr('aria-controls'));
				$transcriptContent.slideToggle();

				var isExpanded = $(this).attr('aria-expanded') === 'true';

				if (isExpanded) {
					$(this).attr('aria-label', 'Click to open and read the video transcript');
					$(this).text('Read Transcript');
					$(this).attr('aria-expanded', 'false');
				} else {
					$(this).attr('aria-label', 'Click to close the video transcript');
					$(this).text('Hide Transcript');
					$(this).attr('aria-expanded', 'true');
					$transcriptContent.focus();  // Move focus to the transcript content.
				}
			});
		}

	});

})(jQuery);
